export type AccountType =
  | 'patient'
  | 'practitioner'
  // | 'private-label-practitioner'
  // | 'private-label-unlicensed'
  | 'student'
  | 'visitor'

export const accountTypes: AccountType[] = [
  'patient',
  'practitioner',
  // 'private-label-practitioner',
  // 'private-label-unlicensed',
  'student',
  'visitor',
]

export const isAccountType = (type: string): type is AccountType =>
  accountTypes.includes(type as AccountType)
